import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL || (process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : 'http://localhost:5000/api');

const postService = {
    getPosts: async (token) => {
        try {
            const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
            const resp = await axios.get(`${API_URL}/posts`, config);
            return resp.data;
        } catch (err) {
            console.error('Error fetching posts:', err);
            throw err;
        }
    },

    createPost: async (postData, token) => {
        try {
            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };

            // Use FormData if there's a file
            if (postData.media) {
                const formData = new FormData();
                formData.append('type', postData.type);
                formData.append('title', postData.title || '');
                formData.append('content', postData.content || '');
                formData.append('metadata', JSON.stringify(postData.metadata || {}));
                formData.append('media', postData.media);

                const resp = await axios.post(`${API_URL}/posts`, formData, {
                    ...config,
                    headers: { ...config.headers, 'Content-Type': 'multipart/form-data' }
                });
                return resp.data;
            }

            // Default JSON
            const resp = await axios.post(`${API_URL}/posts`, postData, {
                ...config,
                headers: { ...config.headers, 'Content-Type': 'application/json' }
            });
            return resp.data;
        } catch (err) {
            console.error('Error creating post:', err);
            throw err;
        }
    },

    deletePost: async (id, token) => {
        try {
            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };
            const resp = await axios.delete(`${API_URL}/posts/${id}`, config);
            return resp.data;
        } catch (err) {
            console.error('Error deleting post:', err);
            throw err;
        }
    },

    // --- Interactions ---

    toggleLike: async (postId, type, token) => {
        const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
        const res = await axios.post(`${API_URL}/interactions/like`, { postId, type }, config);
        return res.data;
    },

    addComment: async (postId, content, token, parentId = null) => {
        const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
        const res = await axios.post(`${API_URL}/interactions/comment`, { postId, content, parentId }, config);
        return res.data;
    },

    getComments: async (postId) => {
        const res = await axios.get(`${API_URL}/interactions/comments/${postId}`);
        return res.data;
    },

    handleFeedAction: async (type, targetId, token) => {
        const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
        const res = await axios.post(`${API_URL}/interactions/action`, { type, targetId }, config);
        return res.data;
    },

    updatePost: async (postId, postData, token) => {
        const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
        const res = await axios.put(`${API_URL}/posts/${postId}`, postData, config);
        return res.data;
    }
};

export default postService;
